<template>  
  <div class='psa-card__comment-wrapper' :class="{ 'ml-3': comment.parent_id }">
    <div class='psa-card__comment'>
      <div class="psa-card__comment-header">
        <span class='psa-card__commenter-name'>
          {{comment.attendee_name}}
        </span>
        <div class='psa-card__comment-time'>
          {{ this.createdFromNow() }}
        </div>
      </div>
      <div class="psa-card__comment-content">
        <div class="comment-text" v-if="!isEditing">
          {{comment.comment}}
        </div>
        <div class="psa-card__comment-editor" v-else>
          <input type="text" class="edited-comment" v-model="editedComment" @keyup.enter="saveEdit" />
          <button class="cancel-edit" @click="cancelEdit">Cancel</button>
          <button class="save-edit" @click="saveEdit">Save</button>
        </div>
        <div class="psa-card__comment-actions" v-if="myComment">
          <a class="action-btn edit-comment-btn" @click="editComment()">
            <i class="far fa-edit"></i>
          </a>
          <a class="action-btn" data-toggle="tooltip" data-placement="top" title="Delete Comment" @click="openModal">
            <i class="far fa-trash text-danger"></i>
          </a>
        </div>
      </div>
    </div>
    <div class="psa-card__comment-sub-wrapper">
      <div class="base-comments-actions-wrapper">
        <a id="comment-like-text" class="action-btn" @click='toggleLike()'>Like</a>
        <div class="psa-card__comment-likes-wrapper">
          <div class='likes-count-container' @click='toggleLike()'>
            <i v-show="this.iLiked" class="fas fa-2x fa-heart"></i>
            <i v-show="!this.iLiked" class="fal fa-2x fa-heart"></i>
          </div>
          <div v-if="this.hasLikes" class='likes-count'>
            {{ (comment.likes.length > 0) ? comment.likes.length : '' }}
          </div>
        </div>
        <span id="comment-like-divider-base">|</span>
        <div class="psa-card__comment-reply">
          <a class="action-btn" style="padding-left: 10px;" @click="isReplying = !isReplying">{{ lang.get('event_strings.photo_stream.reply_text') }}</a>
        </div>
      </div>
      <div class="base-psa-card__comment-actions" v-if="myComment">
          <a class="action-btn edit-comment-btn" @click="editComment()">
            <i class="far fa-edit"></i>
          </a>
          <a class="action-btn" data-toggle="tooltip" data-placement="top" title="Delete Comment" @click="openModal">
            <i class="far fa-trash text-danger"></i>
          </a>
      </div>
    </div>
    <div v-show="isReplying">
      <div class='psa-card__reply-form'>
        <input aria-label="Reply text Field" type='text' class='psa-card__reply-input' :ref="'reply-'+comment.id" :placeholder=" lang.get('event_strings.photo_stream.add_reply')">
        <div 
          tabindex="0" 
          class='psa-card__reply-submit' 
          @click="addReply()"
        >
          <i class="fa fa-reply" aria-hidden="true"></i>
        </div>
      </div>
    </div>
    <photo-stream-comment
        v-for='comment in comment.replies'
        :key="comment.id"
        v-bind:comment="comment"
        v-bind:photo="photo"
        v-bind:eventAttendee="eventAttendee"
        @edit-comment="handleNestedEditComment"
        @delete-comment="handleNestedDeleteComment"
      >
      </photo-stream-comment>


      <!-- Delete Modal -->
      <photo-stream-modal 
          v-if='showDeleteModal'
          v-on:close="closeModal"
        >
          <template #header>
            <div class='title delete-comment-title'>
              Delete Comment
            </div>
          </template>
          <template #body>
            <div class="delete-comment-modal-container">
              <div class="delete-comment-modal__text">Are you sure you want to permanently delete this Comment?</div>
            </div>
            <br>
            <div class="pull-right delete-comment-button-container">
              <button aria-label="Cancel Button" type="button" class="btn modal-close btn-danger mr-2" v-on:click="closeModal">Cancel</button>
              <button aria-label="Button to delete comment" type="button" class="btn modal-close btn-success mr-2" v-on:click="deleteComment">Delete</button>
            </div>
          </template>
        </photo-stream-modal>
        <!-- End Delete Modal -->
  </div>
</template>

<script>
import axios from 'axios';
export default {

  props: ['comment','photo','eventAttendee'],

  data () {
    return {
      isReplying: false,
      isEditing: false,
      editedComment: '',
      showDeleteModal: false
    }
  },

  computed: {

    attendeeName () {
      return this.photo.attendee_name
    },

    momentCreatedAt () {
      return new moment.utc(this.comment.created_at)
    },

    myComment () {
      return this.comment.event_attendee_id === this.eventAttendee.id
    },

    myLike () {
      if (!this.comment.likes || !this.comment.likes.length) return false
      return this.comment.likes.find((like) => like.event_attendee_id === this.eventAttendee.id)
    },

    iLiked () {
      return !!this.myLike
    },

    hasLikes () {
      return this.comment.likes && this.comment.likes.length > 0
    },

  },

  methods: {

    handleNestedEditComment(comment, editedText) {
      this.$emit('edit-comment', comment, editedText);
    },

    handleNestedDeleteComment(comment) {
      this.$emit('delete-comment', comment);
    },

    openModal () {
      this.showDeleteModal = true
    },

    closeModal () {
      this.showDeleteModal = false
    },

    editComment () {
      this.isEditing = true;
      this.editedComment = this.comment.comment;
    },

    deleteComment () {
      this.$emit('delete-comment', this.comment)

      this.closeModal()
    },

    cancelEdit() {
      this.isEditing = false;
    },
    saveEdit() {
      this.$emit('edit-comment', this.comment, this.editedComment)

      this.isEditing = false;
    },

    toggleLike () {
      this.iLiked 
        ? EventBus.$emit('unlikeComment', this.photo, this.comment, this.myLike)
        : EventBus.$emit('likeComment', this.photo, this.comment)
    },

    addReply () {
      var data = {
        'parentId': this.comment.id,
        'replyText': this.$refs[`reply-${this.comment.id}`].value
      }

      EventBus.$emit(`submitComment-${this.photo.id}`, data)
      this.$refs[`reply-${this.comment.id}`].value = ''
    },

    createdFromNow () {
      return this.momentCreatedAt.fromNow()
    },
  },

};
</script>

<style scoped>
  .psa-card__comment-wrapper {
    margin-bottom: 1.5rem;
  }

  .psa-card__comment-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .psa-card__commenter-name {
    font-weight: bold;
  }

  .psa-card__comment-time {
    font-size: small;
    font-style: italic;
  }

  .psa-card__comment-content {
    display: flex;
    justify-content: space-between;
  }

  .psa-card__comment-likes-wrapper {
    display: flex;
    align-items: center;
    border-right: .75px solid black;
    padding-right: 10px;
  }

  .likes-count-container {
    font-size: 8px;
  }

  .likes-count {
    padding-left: 6px;
  }

  .psa-card__comment-sub-wrapper {
    display: flex;
    align-items: center;
    margin-bottom: .6rem;
  }

  .psa-card__reply-form {
    display: flex;
    align-items: center;
    margin: 10px 0;
  }

  .psa-card__reply-input {
    width: 100%;
    min-height: 32px;
    border-radius: 15px;
    padding: 0 10px;
    margin-right: 1em;
    border: 1px solid rgba(156,156,156,0.75);
  }

  .psa-card__reply-submit {
    font-weight: 600;
  }

  .action-btn {
    font-weight: 500;
    text-decoration: none;
  }

  .divider {
    margin: 0 .5rem;
  }

  .psa-card__comment-actions {
    display: flex;
  }

  .edit-comment-btn {
    margin-left: 10px;
    padding: 0 10px;
  }

  .delete-comment-modal__text {
    text-align: center;
  }

  #comment-like-divider-base,
  .base-psa-card__comment-actions {
    display: none;
  }

  .base-comments-actions-wrapper {
    display: flex;
    align-items: center;
  }

  #comment-like-text {
    padding-right: 10px;
  }
</style>
